import React from 'react';
import { BrandLogo } from '@bayesprep/shared-ui/brand';

interface StudentLogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showText?: boolean;
  className?: string;
  textColor?: 'default' | 'white';
}

const StudentLogo: React.FC<StudentLogoProps> = ({ size = 'md', showText = false, className = '', textColor = 'default' }) => (
  <BrandLogo variant="student" size={size} showText={showText} className={className} textColor={textColor} subtitle={'Student Portal'} />
);

export default StudentLogo;
